export enum InfoBlockVariant {
  PRIMARY = 'primary',
  ERROR = 'error',
}

export const infoBlockVariants = {
  [InfoBlockVariant.PRIMARY]: 'bg-[#F2F8FF]',
  [InfoBlockVariant.ERROR]: 'bg-[#FCE7E7]',
};
